/**
 * @param {string} [cookies='']
 * @returns {string}
 */
const buildAuthorizationHeader = (cookies = '') => {
  const findToken = new RegExp(/"token":"(\w+)"/, 'g');
  const token = findToken.exec(cookies);
  if (token) {
    return `FC-API ${token ? `token=${token[1]}` : ''}`;
  }
  return '';
};

export default buildAuthorizationHeader;
